// extracted by mini-css-extract-plugin
module.exports = {"spinningLoading":"styles_spinningLoading__35zLT","rotating":"styles_rotating__7W40t"};